//输入控件
import React, {Component}  from 'react';
import './ToggleControl.less'

//图标为false时不显示
class ToggleControl extends Component {

    //构造函数
    constructor(props, context) {
        //写构造方法时  必须实现父类的构造方法  否则构造失败  报错
        super(props, context);
    }
    /*================自定义事件====================*/

    render(){
      const {Src,value} = this.props;
      let isShow = typeof(value) == 'string' ? value == 'true' : value;

      if(!isShow){
        return null;
      }
      return (<div className='toggleControl'>
                <span className={`icon iconfont icon${Src}`}/>
              </div>);
    }
}
export default ToggleControl;
